export interface RegionInfo {
  culture: string;
  currency: string;
}

export const getBrowserRegionDefaults = (): RegionInfo => {
  const culture = navigator.language || 'en-US';
  const region = culture.split('-')[1]?.toUpperCase() || 'US';

  const currencyMap: Record<string, string> = {
    'US': 'USD',
    'IN': 'INR',
    'GB': 'GBP',
    'JP': 'JPY',
    'CN': 'CNY',
    'CA': 'CAD',
    'AU': 'AUD',
    'CH': 'CHF',
    'RU': 'RUB',
    'KR': 'KRW',
    'SG': 'SGD',
    'NZ': 'NZD',
    'ZA': 'ZAR',
    // Eurozone countries
    'AD': 'EUR', 'AT': 'EUR', 'BE': 'EUR', 'CY': 'EUR', 'EE': 'EUR', 'FI': 'EUR',
    'FR': 'EUR', 'DE': 'EUR', 'GR': 'EUR', 'IE': 'EUR', 'IT': 'EUR', 'LV': 'EUR',
    'LT': 'EUR', 'LU': 'EUR', 'MT': 'EUR', 'MC': 'EUR', 'ME': 'EUR', 'NL': 'EUR',
    'PT': 'EUR', 'SM': 'EUR', 'SK': 'EUR', 'SI': 'EUR', 'ES': 'EUR', 'VA': 'EUR'
  };

  const currency = currencyMap[region] || 'USD';

  return { culture, currency };
};

export const AVAILABLE_CULTURES = [
  { code: 'en-US', name: 'English (United States)' },
  { code: 'en-IN', name: 'English (India)' },
  { code: 'hi-IN', name: 'Hindi (India)' },
  { code: 'en-GB', name: 'English (United Kingdom)' },
  { code: 'fr-FR', name: 'French (France)' },
  { code: 'de-DE', name: 'German (Germany)' },
  { code: 'ja-JP', name: 'Japanese (Japan)' },
  { code: 'zh-CN', name: 'Chinese (Simplified, China)' },
  { code: 'es-ES', name: 'Spanish (Spain)' },
];

export const AVAILABLE_CURRENCIES = [
  { code: 'USD', name: 'USD - US Dollar ($)' },
  { code: 'INR', name: 'INR - Indian Rupee (₹)' },
  { code: 'GBP', name: 'GBP - British Pound (£)' },
  { code: 'EUR', name: 'EUR - Euro (€)' },
  { code: 'JPY', name: 'JPY - Japanese Yen (¥)' },
  { code: 'CNY', name: 'CNY - Chinese Yuan (¥)' },
  { code: 'CAD', name: 'CAD - Canadian Dollar ($)' },
  { code: 'AUD', name: 'AUD - Australian Dollar ($)' },
  { code: 'CHF', name: 'CHF - Swiss Franc (CHF)' },
];
